

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.openbutton', ['squid']).factory('$OpenButtonModel', function ($Model, $Api) {
        return $Model.extend('$OpenButtonModel', {
            api: new $Api({
                uri: '/api/openbutton',
                postAttempts: 2,
                cache: true
            })
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/openButton/index.js
// module id = ./components/xo-models/src/openButton/index.js
// module chunks = 1